module.exports = __webpack_public_path__ + "static/media/oracle_thumbnail.8ac685e1.png";